import * as base from './base.jsx';

class Tabs extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      toggled: false
    });
  }

  indexChanged(index) {
    this.setState({
      toggled: false
    });

    if (this.props.tabChanged) {
      this.props.tabChanged(index);
    }
  }

  mobileTabsToggled() {
    this.setState({
      toggled: !this.state.toggled
    });
  }

  render() {
    var loopIndex = 0;
    var mobileLoopIndex = 0;
    var secondaryLoopIndex = 0;
    var toggledClass = this.state.toggled ? " toggled" : "";

    return <div className="tabs">
      <nav className="tabs-navigation">
        <ul className="tabs-menu">
          { this.props.children.map(child => {
              var liClass = "tabs-menu-item";
              if (this.props.tabIndex == loopIndex) {
                liClass += " is-active";
              }
              loopIndex += 1;
              var tabHeader = <a>{ child.props.title }</a>
              if (child.props.header) {
                tabHeader = child.props.header
              }
              return <li
                className={ liClass }
                onClick={ this.indexChanged.bind(this, loopIndex-1) }
                key={ loopIndex }
              >
                { tabHeader }
              </li>
            })
          }
        </ul>
      </nav>
      <nav className={"tabs-navigation mobile" + toggledClass}>
        <div className="selected-tab" onClick={this.mobileTabsToggled.bind(this)}>
          { React.Children.toArray(this.props.children)[this.props.tabIndex].props.title }
        </div>
        <div className="list">
          { this.props.children.map(child => {
            mobileLoopIndex += 1;
              return <div
                onClick={ this.indexChanged.bind(this, mobileLoopIndex-1) }
                key={ mobileLoopIndex }
              >
                <a>{ child.props.title }</a>
              </div>
            })
          }
        </div>
      </nav>
      <article className="tab-panel">
        { this.props.children.map(child => {
            var blockClass = "hidden";
            if (secondaryLoopIndex == this.props.tabIndex) {
              blockClass = "shown";
            }
            secondaryLoopIndex += 1;

            return <div
              className={blockClass}
              key={secondaryLoopIndex}
            >
              { child }
            </div>
          })
        }
      </article>
    </div>
  }
}

class TabPanel extends base.BaseComponent {
  getDefaultState() {
    return $.extend(super.getDefaultState(), {
      currentIndex: 0
    });
  }

  getTabHeader() {
    return <a>{ this.props.title }</a>
  }

  render() {
    return <div>
      { this.props.children }
    </div>
  }
}

module.exports = {
  Tabs: Tabs,
  TabPanel: TabPanel
}
